import { checkVisibility, matchElementRange, ViewMode } from '@playbooks/action-cards-utils/src'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import makeSeparatorScopes from './makeSeparatorScopes'
import type { Slide } from '../types'
import getRequitedNotFilledFieldIds from './getRequitedNotFilledFieldIds'

export default function getSectionsSet({
  actionCards,
  headersCount,
  hideSeparatorsAbility,
  viewMode,
}: {
  actionCards: ActionCard
  headersCount?: number | null
  hideSeparatorsAbility?: boolean
  viewMode?: ViewMode
}) {
  const sections = actionCards.sections.filter(section => {
    return checkVisibility(section, actionCards) && matchElementRange(section, actionCards)
  })

  const { scopes, visiblePinnedSections } = makeSeparatorScopes({
    sections,
    conditionalItems: actionCards.conditionalItems || [],
    displayHeadersCount: headersCount,
    hideSeparatorsAbility: hideSeparatorsAbility,
    isFunnelView: viewMode === ViewMode.FUNNEL,
  })

  const slidesMap: Record<number, Slide> = {}

  scopes.forEach((scope, index) => {
    const requiredDataIds = getRequitedNotFilledFieldIds(scope.sections, actionCards.conditionalItems || [])
    slidesMap[index] = { isFilled: requiredDataIds.length === 0, requiredDataIds }
  })

  return { scopes, visiblePinnedSections, slides: slidesMap }
}
